// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyA_lAYoywvc5bP_HCPNPKRzz7YRwFjZ0H8",
  authDomain: "gym-app-25e66.firebaseapp.com",
  projectId: "gym-app-25e66",
  storageBucket: "gym-app-25e66.appspot.com",
  messagingSenderId: "1057162415204",
  appId: "1:1057162415204:web:828ccbfa8d864ec23ea371",
  measurementId: "G-D4BZJKP522",
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

export const auth = getAuth(app);
export const firestore = getFirestore(app);

export default auth;
